"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const content_wrapper_1 = require("./utils/content-wrapper");
const CommentPrimitive = 'Comment';
/**
 * A comment displays discussions and user feedback.
 *
 * @see [Comment](https://developer.atlassian.com/platform/forge/ui-kit/components/comment/) in UI Kit documentation for more information
 */
const Comment = ({ avatar, content, ...rest }) => {
    return ((0, jsx_runtime_1.jsxs)(CommentPrimitive, { ...rest, children: [(0, jsx_runtime_1.jsx)(content_wrapper_1.ContentWrapper, { name: "avatar", children: avatar }), (0, jsx_runtime_1.jsx)(content_wrapper_1.ContentWrapper, { name: "content", children: content })] }));
};
exports.Comment = Comment;
